const $ = jQuery;

class AnchorScroll {

    constructor(){
        $(document).on('click', 'a[href^="#"]', e=>this.click(e));
        if( window.location.hash ){
            this.maybeScroll( window.location.hash.replace(/^#/, ''));
        }
    }

    click(e){
        const $link = $(e.currentTarget);
        this.maybeScroll($link.attr('href').replace(/^#/,''));
    }

    maybeScroll( id ){
        try {
            console.log( 'maybeScroll', id);
            this.scrollTo( id );
        }
        catch( e ){
            // not a good link
        }
    }

    scrollTo(id){
        const $el = this.get(id);
        if( !$el ){
            return;
        }
        const _id = $el.attr('id');
        $el.attr('id', null);
        setTimeout(()=>{
            $('html,body').animate({
                scrollTop: this.getPosition($el)
            }, 300, () => {
                $el.attr('id', _id);
            });
        },1);
    }

    get(id){
        try {
            const $el = $('#'+id+',[data-id="'+id+'"]');
            console.log( 'get(id)', $el );
            if( !$el.length ){
                return false;
            }
            return $el;
        }
        catch(e){
            return false;
        }
    }

    getPosition($el){
        // get the header
        const $header = $('header.page-header');
        const headerPosition = $header.css('position');
        let offset = $('body').offset().top + 20;
        if( ['fixed','sticky'].includes( headerPosition ) ){
            offset += $header.height() + 80
        }
        return $el.offset().top - offset;
    }

}


export default {
    init(){
        new AnchorScroll();
    }
}